module.exports = __webpack_public_path__ + "media/images/arrow-down-4d568f42c0104b09aeee5c63a5953b25.svg";